// extracted by mini-css-extract-plugin
module.exports = {"Container3DVizualSmall":"styles_Container3DVizualSmall__3RWt3","callModalBtn":"styles_callModalBtn__1pkjK","bigThreeDModal":"styles_bigThreeDModal__3vu5F"};